import { useState as useReactState } from 'react'

export const useState = useReactState

export default useState
